<template>
  <div id="list-client-portal-card" v-if="clientPortal != null">
    <v-card class="mt-3">
      <v-card-title>
        Liste des cartes
        <v-spacer></v-spacer>
        <v-btn
          v-if="isGrantedUser()"
          color="primary"
          icon
          @click.stop="createCardDialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-card-dialog
          :client-portal="clientPortal"
          :open.sync="createCardDialog"
          v-if="createCardDialog && isGrantedUser()"
        ></create-card-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row v-if="cards != null">
          <v-col cols="12">
            <card-datatable :cards="cards"></card-datatable>
          </v-col>
        </v-row>
        <div v-else>
          <p>Pas de cartes pour ce client.</p>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import router from "@/router";
import { useCard } from "@/composables/card";
import CardDatatable from "@/components/Card/CardDatatable";
import { useClientPortal } from "@/composables/client-portal";
import CreateCardDialog from "@/components/Card/CreateCardDialog";
import { useRoles } from "../../composables/roles";

export default {
  components: {
    CreateCardDialog,
    CardDatatable,
  },
  setup() {
    /* Import des API */
    const { listCards, cards, cardData } = useCard();
    const { showClientPortal } = useClientPortal();
    const { currentClientPortal: clientPortal } = useClientPortal();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const clientId = router.currentRoute.params.id;

    /* Cycle de vie */
    onMounted(async () => {
      await listCards(clientId);
      await showClientPortal(clientId);
    });

    return {
      cards,
      clientPortal,
      ...toRefs(cardData),
      isGrantedUser,
    };
  },
};
</script>
